import moment, { weekdaysMin } from "moment";

import CalendarDate from "./CalendarDate";
import styles from "./CalendarMonth.module.scss";
import BodyText from "../BodyText";
import generateCalendarWeeks from "../../../../../utils/generateCalendarWeeks";
import getCalendarWeekDates from "../../../../../utils/getCalendarWeekDates";

export default function CalendarMonth() {
  return (
    <div className={styles.container}>
      <div className={styles.calendarWeekDays}>
        {weekdaysMin(true).map(weekDay => (
          <BodyText key={weekDay} as="span" color="body-2">
            {weekDay}
          </BodyText>
        ))}
      </div>
      <div className={styles.calendarMonth}>
        {generateCalendarWeeks(moment()).map(calendarWeek => (
          <div key={calendarWeek.week} className={styles.calendarWeek}>
            {getCalendarWeekDates(calendarWeek).map(date => (
              <CalendarDate date={date} />
            ))}
          </div>
        ))}
        {false && <div className={styles.shimmerOverlay} />}
      </div>
    </div>
  );
}
